// import { slider } from 'utility';

// slider({
//   containerClass: '.carousel--impact',
//   slidesClass: '.carousel__slides',
//   slideClass: '.slide',
//   currentSlideClass: '.slide--current',
//   nextClass: '.carousel__paginate--next',
//   prevClass: '.carousel__paginate--prev',
//   currentPageClass: '.carousel__page--current',
//   currentSlideProgressClass: '.slide__progress'
// });

const sliderActionsColorTweak = ({ target }) => {
  if (!target.matches('.carousel--impact')) return;

  const isDark = target.querySelector('.slide--current').matches('.slide--dark') || target.querySelector('.slide--current').matches('.slide--image') || target.querySelector('.slide--current').matches('.slide--blue');

  target.querySelector('.carousel__actions').classList[!isDark ? 'add' : 'remove']('carousel__actions--dark');
};

document.addEventListener('slider:change', sliderActionsColorTweak);
document.addEventListener('slider:loaded', sliderActionsColorTweak);
